var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootprints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.38,13.72c-.12-.4-.53-.63-.93-.51l-4.8,1.4c-.19,.06-.35,.19-.45,.36-.1,.17-.12,.38-.06,.57l.25,.85c.37,1.25,1.51,2.06,2.75,2.06,.27,0,.54-.04,.8-.12l.74-.22c.73-.21,1.34-.7,1.71-1.37,.37-.67,.45-1.44,.24-2.18l-.25-.85Zm-1.3,2.31c-.17,.32-.46,.55-.81,.65l-.74,.22c-.72,.21-1.48-.2-1.69-.92l-.04-.13,3.36-.98,.04,.13c.1,.35,.06,.72-.11,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.57,10.96c-.24-2.01-.81-3.94-1.68-5.73-.29-.59-.61-1.17-.96-1.73-.64-1.02-1.94-1.48-3.16-1.12h-.03c-.96,.29-1.69,.99-1.95,1.9-.27,.91-.42,1.84-.43,2.77-.05,2.63,.91,4.67,1.73,5.92,.14,.21,.38,.34,.63,.34,.07,0,.14,0,.21-.03l5.11-1.5c.35-.1,.58-.45,.53-.81Zm-5.52,.71c-.62-1.08-1.24-2.66-1.2-4.6,.02-.79,.14-1.59,.37-2.37,.12-.41,.48-.74,.94-.88h.03c.58-.18,1.18,.02,1.46,.48,.32,.51,.62,1.05,.88,1.59,.71,1.46,1.2,3.02,1.45,4.63l-3.94,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.36,17.98l-4.76-1.54c-.19-.06-.4-.04-.57,.05-.18,.09-.31,.25-.37,.44l-.27,.85c-.23,.73-.17,1.5,.18,2.18,.35,.68,.94,1.18,1.67,1.42l.74,.24c.29,.09,.59,.14,.88,.14,1.21,0,2.34-.77,2.73-1.98l.27-.84c.13-.39-.09-.82-.48-.94Zm-1.22,1.33c-.23,.72-1,1.11-1.71,.88l-.74-.24h0c-.71-.23-1.11-1-.88-1.71l.04-.13,3.33,1.07-.04,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.52,7.71c-.24-.91-.95-1.64-1.9-1.94h-.03c-1.21-.4-2.52,.03-3.19,1.03-.37,.55-.71,1.12-1.01,1.71-.92,1.77-1.54,3.69-1.83,5.69-.05,.36,.16,.71,.51,.82l5.07,1.64c.08,.02,.15,.04,.23,.04,.24,0,.47-.12,.62-.32,.85-1.23,1.88-3.24,1.89-5.87,0-.93-.11-1.86-.36-2.78Zm-2.46,7.33l-3.91-1.26c.3-1.61,.83-3.15,1.58-4.59,.28-.53,.59-1.06,.93-1.56,.3-.45,.91-.63,1.48-.44h.03c.45,.16,.8,.5,.91,.91,.21,.79,.31,1.59,.31,2.38-.01,1.94-.67,3.5-1.32,4.57Z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprints);
export default __webpack_public_path__ + "static/media/footprints.826e480d51ce16fc75d35101aebfc55e.svg";
export { ForwardRef as ReactComponent };